import { loan_application, LoanApplication } from '@axo/shared/data-access/types';

export function isSubmittedActive(
  application: LoanApplication,
  statusMap: loan_application.LoanApplicationMap,
): boolean {
  const groups = statusMap[application.Status as loan_application.ApplicationStatus]?.Groups;
  if (!groups) return false;
  return (
    groups.includes(loan_application.StatusGroup.Active) &&
    !groups.includes(loan_application.StatusGroup.Incomplete)
  );
}
